<template>
  <div id="endpoint-create">
    <div class="page">
      <div
        class="card"
        :class="{ '-loading': loading }"
      >
        <div class="header">
          <div class="description">
            <h2 class="title">Cadastrar Consulta</h2>
            <p class="subtitle"> Nesta tela você pode cadastrar uma consulta.</p>
          </div>
        </div>

        <div class="body">
          <div class="alert -danger mb-4" v-if="errors.cantCreate">
            <p class="title">Ocorreu um erro!</p>
            <p>Infelizmente não foi possível cadastrar esta consulta, por favor tente novamente.</p>
          </div>

          <form-endpoint
            submit-text="Cadastrar"
            v-model="form"
            :errors="errors.form"
            @submit="storeEndpoint"
          />
        </div>

        <loader v-if="loading"></loader>
      </div>
    </div>
  </div>

</template>

<script>
import FormEndpoint from '@/endpoint/components/FormEndpoint.vue';
import Loader from '@/support/components/Loader.vue';
import { filter } from 'lodash';

export default {
  name: 'Create',

  data() {
    return {
      loading: false,
      form: {
        name: '',
        label: '',
        path: '',
        value: 0,
        tags: [],
        enable: false,
        fields: {},
      },
      errors: {
        cantCreate: false,
        form: {
          name: [],
          label: [],
          path: [],
          value: [],
          tags: [],
          enable: [],
          fields: [],
        },
      },
    };
  },

  methods: {
    /**
     * Store the endpoint.
     *
     * @returns {Promise<void>}
     */
    async storeEndpoint() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'endpoint/storeEndpoint',
          { form: this.form },
        );

        await this.$router.push({ name: 'Endpoint-Index' });
      } catch (err) {
        const { data, status } = err.response || {};

        if (status === 422) {
          this.errors.form.name = data.errors.name || [];
          this.errors.form.label = data.errors.label || [];
          this.errors.form.path = data.errors.path || [];
          this.errors.form.value = data.errors.value || [];
          this.errors.form.tags = data.errors.tags || [];
          this.errors.form.enable = data.errors.enable || [];
          this.errors.form.fields = data.errors.fields || [];

          filter(data.errors, (errors, key) => key.match(/tags.(.*).name/))
            .forEach((errors) => {
              this.errors.form.tags = this.errors.form.tags.concat(errors);
            });

          return;
        }

        this.errors.cantCreate = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset errors.
     */
    resetErrors() {
      this.errors.cantCreate = false;
      this.errors.form.name = [];
      this.errors.form.label = [];
      this.errors.form.path = [];
      this.errors.form.value = [];
      this.errors.form.tags = [];
      this.errors.form.enable = [];
      this.errors.form.fields = [];
    },
  },


  components: {
    FormEndpoint,
    Loader,
  },
};
</script>

<style lang="scss" scoped>

</style>
